module.exports = __webpack_public_path__ + "img/checked.d39f4965.svg";